
import { IMenuItem, PHX_DATE_FORMAT, PhxDateFormatConfig, DATE_INPUT_FIELD } from "./types";
import { enUS, enGB, frCA, es, nl, de } from 'date-fns/locale';

export const DAYS_OF_WEEKS: string[] = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export enum DaysName {
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
}

export enum SELECTOR_PLACEHOLDERS {
  RANGE = 'Date-range',
  DATE = 'Date',
};

export const DEFAULT_MENU_ITEMS: Array<IMenuItem> = [
  {
    label: 'Today',
    valueInDays: 0
  },
  {
    label: 'Last 7 days',
    valueInDays: -7
  },
  {
    label: 'Next 15 days',
    valueInDays: 15
  },
  {
    label: 'Last 30 days',
    valueInDays: -30
  },
  {
    label: 'Last 90 days',
    valueInDays: -90
  },
  {
    label: 'Next 90 days',
    valueInDays: 90
  },
];

export const MAX_MENU_ITEMS_COUNT: number = 6;

export const DATE_FNS_LOCALE_MAP: any = {
  fr: frCA,
  en: enUS,
  'en-GB': enGB,
  es: es,
  nl: nl,
  de: de,
};

export const MONTH_NAMES_BY_LOCALE: Record<string, string[]> = {
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  'en-GB': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  fr: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
  es: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  nl: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  de: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
};

export const HIDE_YEAR_FORMAT_MAPPER = {
  "MM/dd/yyyy": 'MM/dd',
  "MM-dd-yyyy": 'MM-dd',
  "MMM dd, yyyy": 'MMM dd',
  "yyyy-MM-dd": 'MM-dd',
  "dd MMM, yyyy": 'dd MMM',
  "dd MMM yyyy": 'dd MMM',
}

export const DEFAULT_DATE_FORMAT = 'MMM d, yyyy';
export const DEFAULT_DATE_FORMAT_WITHOUT_YEAR = 'MMM d';

export const DIACRITICS_REGEX = /[\u0300-\u036f]/g;
export const SINGLE_DIGIT_REGEX = /^\d$/;
export const SINGLE_UNICODE_LETTER_REGEX = /^\p{L}$/u;
export const ALPHA_CHAR_REGEX = /[a-zA-Z]/;
export const DIGIT_CHAR_REGEX = /\d/;

const dateFormatConfig = (c: PhxDateFormatConfig): PhxDateFormatConfig => c;

export const PHX_DATE_INPUT_FORMAT_CONFIGS: Record<Exclude<PHX_DATE_FORMAT, 'MM/dd/yyyy'>, PhxDateFormatConfig> = {
  [PHX_DATE_FORMAT['MM-dd-yyyy']]: dateFormatConfig({ fieldOrder: [DATE_INPUT_FIELD.MONTH, DATE_INPUT_FIELD.DAY, DATE_INPUT_FIELD.YEAR], separators: ['-', '-'], monthDisplay: 'numeric' }),
  [PHX_DATE_FORMAT['MMM dd, yyyy']]: dateFormatConfig({ fieldOrder: [DATE_INPUT_FIELD.MONTH, DATE_INPUT_FIELD.DAY, DATE_INPUT_FIELD.YEAR], separators: [' ', ', '], monthDisplay: 'alpha' }),
  [PHX_DATE_FORMAT['yyyy-MM-dd']]: dateFormatConfig({ fieldOrder: [DATE_INPUT_FIELD.YEAR, DATE_INPUT_FIELD.MONTH, DATE_INPUT_FIELD.DAY], separators: ['-', '-'], monthDisplay: 'numeric' }),
  [PHX_DATE_FORMAT['dd MMM, yyyy']]: dateFormatConfig({ fieldOrder: [DATE_INPUT_FIELD.DAY, DATE_INPUT_FIELD.MONTH, DATE_INPUT_FIELD.YEAR], separators: [' ', ', '], monthDisplay: 'alpha' }),
  [PHX_DATE_FORMAT['dd MMM yyyy']]: dateFormatConfig({ fieldOrder: [DATE_INPUT_FIELD.DAY, DATE_INPUT_FIELD.MONTH, DATE_INPUT_FIELD.YEAR], separators: [' ', ' '], monthDisplay: 'alpha' }),
};

export enum DATE_PICKER_MODE {
  DATE = 'date',
  MONTH = 'month',
  YEAR = 'year',
};
